'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _Checkbox = require('../../components/Checkbox/Checkbox');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _Product = require('../../helpers/Product');

var _Login = require('../../helpers/Login');

var _Router = require('../../helpers/Router');

var _Cookie = require('../../helpers/Cookie');

var _ValidateTvCode = require('../../helpers/ValidateTvCode');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _LoginEmail = require('./LoginEmail.scss');

var _LoginEmail2 = _interopRequireDefault(_LoginEmail);

var _mobile = require('../../../res/images/icon/mobile.svg');

var _mobile2 = _interopRequireDefault(_mobile);

var _backArrow = require('../../../res/images/common/back-arrow.svg');

var _backArrow2 = _interopRequireDefault(_backArrow);

var _karaoke_tsm_pineapple = require('../../../res/images/welcome/karaoke_tsm_pineapple.png');

var _karaoke_tsm_pineapple2 = _interopRequireDefault(_karaoke_tsm_pineapple);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginEmail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    captcha: state.captcha,
    captchaToken: state.captcha.captchaToken,
    lang: state.auth.lang };
}, { changePopupType: _popup.changePopupType, login: _auth.login, submitLogin: _Login.submitLogin, tvFlowStarted: _auth.tvFlowStarted, pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginEmail, _Component);

  function LoginEmail(props) {
    (0, _classCallCheck3.default)(this, LoginEmail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginEmail.__proto__ || (0, _getPrototypeOf2.default)(LoginEmail)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props$auth = _this.props.auth,
        realm = _this$props$auth.realm,
        productName = _this$props$auth.productName;

    _this.isMusic = realm === _Product.REALM_NAMES.Stingray && productName === _Product.PRODUCT_NAMES.Music;
    return _this;
  }

  (0, _createClass3.default)(LoginEmail, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var tvCode, response, _tvCode, error, params, clientId;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // check if we're on the TV flow
                tvCode = sessionStorage.getItem(_Cookie.tvCodeSessionStorageName);

                if (!tvCode) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return (0, _ValidateTvCode.validateTvCode)(tvCode);

              case 5:
                response = _context.sent;

                if (!response) {
                  _context.next = 18;
                  break;
                }

                _tvCode = response.tvCode, error = response.error;
                params = new URLSearchParams(window.location.search);
                clientId = params.get("client_id");

                if (!(!error && clientId)) {
                  _context.next = 15;
                  break;
                }

                this.props.tvFlowStarted(_tvCode, clientId);
                sessionStorage.setItem(_Cookie.tvCodeSessionStorageName, _tvCode);
                _context.next = 16;
                break;

              case 15:
                throw new Error('Cookie ' + _Cookie.tvCodeSessionStorageName + ' invalid.');

              case 16:
                _context.next = 19;
                break;

              case 18:
                throw new Error('Could not validate ' + _Cookie.tvCodeSessionStorageName);

              case 19:
                _context.next = 26;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0);
                this.setState({ tvCodeError: _context.t0 });
                if (_context.t0.response.status === 400) {
                  this.props.pushState('/' + this.props.auth.productName.toLowerCase() + '/' + _Router.RouterConst.TV);
                }

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 21]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.loggingIn && !nextProps.auth.loggingIn) {
        if (nextProps.auth.loginError) {
          this.clearInput();
          this.editLoadingState(false);
          var responseBody = nextProps.auth.loginError.response.body;
          if (responseBody.code === _Error.ErrorConst.InvalidValue && responseBody.field === _Error.ErrorFieldConst.EmailPassword) {
            this.editLoginError(true);
          }
          if (nextProps.auth.loginError.response.body.code === _Error.ErrorConst.InvalidCaptcha) {
            this.editLoginError(true);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$auth = this.props.auth,
          productName = _props$auth.productName,
          clientId = _props$auth.clientId,
          bypassMaintenance = _props$auth.bypassMaintenance;

      var titleMessage = this.getTitleBlock();
      var orComponent = this.getOrComponent();
      var rememberMeComponent = this.getRememberMeComponent();
      var forgotPasswordComponent = this.getForgotPasswordComponenent();
      var submitButton = this.getSubmitButton();
      var qrButton = this.getQrButton();
      var errorMessageComponent = this.getErrorMessage();
      var tvCodeErrorMessageComponent = this.getTvCodeErrorMessage();
      var emailPlaceholder = this.getEmailPlaceholder();
      var formFooter = this.getFormFooter();

      var captchaComponent = _react2.default.createElement(_components.Captcha, {
        ref: function ref(el) {
          _this2.captchaEl = el;
        },
        error: this.state.captchaError,
        editCaptchaError: this.editCaptchaError,
        captchaTypeRequired: LoginEmail.beCalls,
        onReCaptchaValidated: this.reCaptchaValidated
      });

      var socialLoginComponent = _react2.default.createElement(_components.SocialLoginButtons, null);
      var inMaintenance = _config2.default.maintenance && bypassMaintenance !== "true";

      return _react2.default.createElement(
        'div',
        { className: _LoginEmail2.default.loginEmail },
        this.isMusic && _react2.default.createElement(
          'div',
          { className: _LoginEmail2.default.backButton },
          _react2.default.createElement(_components.BackButton, {
            className: _LoginEmail2.default.back,
            pathname: this.props.location.pathname,
            icon: _backArrow2.default
          })
        ),
        inMaintenance && _react2.default.createElement(
          'div',
          { className: _LoginEmail2.default.maintenance },
          _react2.default.createElement(_components.MaintenanceBanner, null)
        ),
        _react2.default.createElement(
          'div',
          { className: _LoginEmail2.default.content + ' ' + (inMaintenance ? _LoginEmail2.default.contentMaintenance : "") },
          titleMessage,
          _react2.default.createElement(
            _reactBootstrap.Form,
            { className: _LoginEmail2.default.form },
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { role: 'form' },
              _react2.default.createElement(_components.EmailInput, {
                handleEnterKey: this.handleEnterKey,
                handleOnChange: this.handleOnChange,
                intl: this.props.intl,
                placeholder: emailPlaceholder
              }),
              _react2.default.createElement(_components.PasswordInput, {
                editPassword: this.handlePasswordChange,
                handleEnterKey: this.handleEnterKey,
                handleOnChange: this.handleOnChange,
                intl: this.props.intl,
                name: 'password',
                password: this.state.password,
                placeholder: _DefaultString.translations.Password
              }),
              this.isMusic ? _react2.default.createElement(
                'div',
                { className: _LoginEmail2.default.componentWrapper },
                _react2.default.createElement(
                  'div',
                  { className: _LoginEmail2.default.rememberMeWrapper },
                  forgotPasswordComponent,
                  rememberMeComponent
                ),
                captchaComponent,
                errorMessageComponent,
                tvCodeErrorMessageComponent,
                submitButton,
                orComponent,
                socialLoginComponent,
                qrButton
              ) : _react2.default.createElement(
                'div',
                { className: _LoginEmail2.default.componentWrapper },
                _react2.default.createElement(
                  'div',
                  { className: _LoginEmail2.default.loginPasswordWrapper },
                  rememberMeComponent,
                  forgotPasswordComponent
                ),
                errorMessageComponent,
                tvCodeErrorMessageComponent,
                submitButton,
                captchaComponent,
                orComponent,
                socialLoginComponent
              )
            )
          ),
          (0, _Product.isKaraokeTsm)(productName, clientId) && formFooter
        )
      );
    }
  }]);
  return LoginEmail;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  captchaToken: _react.PropTypes.string,
  intl: _reactIntl.intlShape.isRequired,
  lang: _react.PropTypes.string,
  login: _react.PropTypes.func,
  tvFlowStarted: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _class2.beCalls = [_Captcha.CaptchaCallNames.Login], _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    captchaError: false,
    loading: false,
    password: '',
    loginError: false,
    tvCodeError: false
  };

  this.getEmailPlaceholder = function () {
    var _props$auth2 = _this3.props.auth,
        productName = _props$auth2.productName,
        clientId = _props$auth2.clientId;

    return (0, _Product.isKaraokeTsm)(productName, clientId) ? _DefaultString.translations.Email : _DefaultString.translations.EmailAddress;
  };

  this.getOrComponent = function () {
    var orText = _DefaultString.translations.OrContinueWith;
    return _react2.default.createElement(
      'div',
      { className: _LoginEmail2.default.optionSeparator },
      _react2.default.createElement(_reactIntl.FormattedMessage, orText)
    );
  };

  this.getRememberMeComponent = function () {
    return _react2.default.createElement(_components.RememberMe, { className: _LoginEmail2.default.rememberMe, theme: _Checkbox.CheckboxTheme.APP_COLOR });
  };

  this.getForgotPasswordComponenent = function () {
    return _react2.default.createElement(
      'div',
      { className: _LoginEmail2.default.forgotPassword, onClick: _this3.forgotPassword },
      _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ForgotPassword)
    );
  };

  this.getSubmitButton = function () {
    var _props$auth3 = _this3.props.auth,
        productName = _props$auth3.productName,
        emailErrorMessage = _props$auth3.emailErrorMessage;

    var confirmTheme = productName === _Product.PRODUCT_NAMES.Classica || productName === _Product.PRODUCT_NAMES.Qello || _this3.isMusic ? _BaseButton.ButtonTheme.CallToAction : '';
    return _react2.default.createElement(_components.BaseButton, {
      className: _LoginEmail2.default.submit,
      onClick: _this3.loginButtonClicked,
      buttonString: _DefaultString.translations.Continue,
      isInactive: !!emailErrorMessage || _this3.state.loginError,
      loading: _this3.state.loading,
      theme: confirmTheme
    });
  };

  this.getSignUpText = function () {
    return _DefaultString.translations.CreateAnAccount;
  };

  this.getTitleBlock = function () {
    var titleMessage = _this3.getTitle();
    return _react2.default.createElement(
      'span',
      { className: _LoginEmail2.default.title },
      titleMessage,
      ' \xA0',
      _react2.default.createElement(
        'span',
        { onClick: _this3.navigateSignUp, className: _LoginEmail2.default.link },
        _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Or),
        ' ',
        _react2.default.createElement(_reactIntl.FormattedMessage, _this3.getSignUpText())
      )
    );
  };

  this.getQrButton = function () {
    var hasQrFeature = _this3.hasQrFeature();
    return hasQrFeature ? _react2.default.createElement(_components.BaseButton, { theme: _BaseButton.ButtonTheme.darkText, className: _LoginEmail2.default.connectWithMobile, onClick: _this3.qrLogin, buttonString: _DefaultString.translations.ConnectWithMobile, icon: _mobile2.default }) : null;
  };

  this.getErrorMessage = function () {
    var errorMessage = _this3.isMusic ? _DefaultString.translations.ErrorInvalidCredentialsMessageMusic : _DefaultString.translations.ErrorInvalidCredentialsMessage;
    return _this3.state.loginError ? _react2.default.createElement(
      'div',
      { className: _LoginEmail2.default.errorMessage },
      _react2.default.createElement(_reactIntl.FormattedHTMLMessage, errorMessage)
    ) : '';
  };

  this.getTvCodeErrorMessage = function () {
    var tvCodeErrorMessage = _DefaultString.translations.ErrorRetryTitle;
    return _this3.state.tvCodeError ? _react2.default.createElement(
      'div',
      { className: _LoginEmail2.default.errorMessage },
      _react2.default.createElement(_reactIntl.FormattedHTMLMessage, tvCodeErrorMessage)
    ) : '';
  };

  this.getTitle = function () {
    return _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Login);
  };

  this.getFormFooter = function () {
    var element = null;
    var _props$auth4 = _this3.props.auth,
        productName = _props$auth4.productName,
        clientId = _props$auth4.clientId,
        isMobile = _props$auth4.isMobile;

    if ((0, _Product.isKaraokeTsm)(productName, clientId) && !isMobile) {
      element = _react2.default.createElement(
        'div',
        { className: _LoginEmail2.default.karaokePineapple },
        _react2.default.createElement('img', { src: _karaoke_tsm_pineapple2.default })
      );
    }
    return element;
  };

  this.clearInput = function () {
    _this3.setState({ password: '' });
  };

  this.editCaptchaError = function (captchaError) {
    _this3.setState({ captchaError: captchaError });
  };

  this.editLoadingState = function (loadingState) {
    _this3.setState({ loading: loadingState });
  };

  this.forgotPassword = function () {
    _this3.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ForgotPassword));
  };

  this.qrLogin = function () {
    _this3.props.pushState((0, _Router.getPath)(_Router.RouterConst.QRLogin));
  };

  this.navigateSignUp = function () {
    _this3.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpEmail));
  };

  this.handleEnterKey = function (event) {
    if (event.key === 'Enter') {
      _this3.loginButtonClicked();
    }
  };

  this.handleOnChange = function () {
    if (_this3.state.loginError) {
      _this3.editLoginError(false);
    }
  };

  this.editLoginError = function (loginError) {
    _this3.setState({ loginError: loginError });
  };

  this.handlePasswordChange = function (password) {
    _this3.setState({ password: password });
  };

  this.loginButtonClicked = function () {
    if (!_this3.props.auth.emailErrorMessage) {
      _this3.captchaEl.getWrappedInstance().executeReCaptcha();
    }
  };

  this.reCaptchaValidated = function (captchaToken) {
    if (captchaToken) {
      (0, _Login.submitLogin)(_this3.props.auth.email, _this3.state.password, _this3.props.lang, captchaToken, _this3.editCaptchaError, _this3.editLoginError, _this3.clearInput, _this3.props.login, _this3.editLoadingState);
    } else {
      _this3.editCaptchaError(true);
    }
  };

  this.hasQrFeature = function () {
    return _this3.props.auth.productName === _Product.PRODUCT_NAMES.Music && !_this3.isSmartSpeaker();
  };

  this.isSmartSpeaker = function () {
    return _this3.props.auth.platform === _Product.PLATFORM_NAMES.SmartSpeaker;
  };
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(LoginEmail);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginEmail/LoginEmail.js
// module id = 2010
// module chunks = 0